'use client';

import { BackNavigationBar, ShareButton } from '@/components';
import { getRouterPath } from '@/components/routerPath';
import { useChannelDetailByIdQuery } from '@/entities/channel';
import { useSalePageQuery } from '@/entities/salePage';
import webViewService from '@/lib/webViewService';
import { getClientSideUserAgent, trackEvent } from '@vuddy/utils';
import { useEffect, useState } from 'react';

const SalesMobileNaviation = ({
  salePageId,
  type,
}: {
  salePageId: number;
  type: 'salePage' | 'gachaPage';
}) => {
  const userAgent = getClientSideUserAgent();
  const { data: salePageResponse } = useSalePageQuery(salePageId);
  const { data: channelResponse } = useChannelDetailByIdQuery(
    salePageResponse?.channelId
  );

  const [isTop, setIsTop] = useState(true);

  useEffect(() => {
    if (type !== 'gachaPage') {
      setIsTop(true);
      return;
    }

    let rafId: number | null = null;
    const updateIsTop = () => {
      const nextIsTop = window.scrollY <= 0;
      setIsTop(prev => (prev === nextIsTop ? prev : nextIsTop));
    };
    const handleScroll = () => {
      if (rafId !== null) return;

      rafId = requestAnimationFrame(() => {
        rafId = null;
        updateIsTop();
      });
    };

    updateIsTop();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
    };
  }, [type]);

  // 배경 색상
  const backgroundColor =
    type === 'salePage'
      ? 'primary'
      : type === 'gachaPage' && !isTop
        ? 'black'
        : 'whiteTransparent';
  // 아이콘 색상
  const iconColor = type === 'gachaPage' ? 'whitePrimary' : 'primary';

  // 타이틀 표시 조건
  const title =
    type === 'salePage' || (type === 'gachaPage' && !isTop)
      ? salePageResponse?.name
      : '';

  const handleShareClick = () => {
    if (type === 'salePage' && salePageResponse) {
      trackEvent('shop', 'click_sale_share', {
        channel_id: salePageResponse.channelId,
        sale_type: salePageResponse.type,
        sale_page_id: salePageId,
      });
    }
  };

  return (
    <BackNavigationBar
      isFixed={true}
      backgroundColor={backgroundColor}
      iconColor={iconColor}
      color={iconColor}
      title={title}
      fallbackUrl={
        webViewService.isAppWebView(userAgent ?? '')
          ? undefined
          : getRouterPath().channelsHome({
              channelUrl: channelResponse?.url ?? '',
              channelId: channelResponse?.id,
            })
      }
      right={<ShareButton iconColor={iconColor} onClick={handleShareClick} />}
    />
  );
};

export default SalesMobileNaviation;
